import { createFileRoute } from "@tanstack/react-router";

import { RoutePage, routeEntry } from "./routeTable";

const entry = routeEntry("/demand/reserved-capacity");

export const Route = createFileRoute("/demand/reserved-capacity")({
  head: () => ({
    meta: [
      { title: "Reserved capacity — LevelLoad" },
      { name: "description", content: "Reserved capacity — LevelLoad transport planning." },
      { property: "og:title", content: "Reserved capacity — LevelLoad" },
      { property: "og:description", content: "Reserved capacity — LevelLoad transport planning." },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
  }),
  component: RouteComponent,
});

function RouteComponent() {
  return <RoutePage entry={entry} />;
}
